import React from "react";
import { View, Text, StyleSheet, Platform } from "react-native";
import { Picker } from "@react-native-picker/picker";

const SelectField = ({
  label,
  value,
  placeholder,
  options,
  onValueChange,
  helperText,
  error,
}) => {
  return (
    <View style={styles.wrapper}>
      <Text style={styles.label}>{label}</Text>
      <View style={[styles.selectWrapper, error ? styles.errorBorder : null]}>
        <Picker
          selectedValue={value}
          onValueChange={onValueChange}
          style={styles.select}
          itemStyle={styles.selectItem}
        >
          <Picker.Item label={placeholder} value="" />
          {options.map((option) => (
            <Picker.Item
              key={option.value ?? option}
              label={option.label ?? option}
              value={option.value ?? option}
            />
          ))}
        </Picker>
      </View>
      <Text style={[styles.helper, error ? styles.errorText : null]}>
        {error || helperText || "\u00a0"}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    width: "100%",
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
    color: "#374151",
    marginBottom: 8,
    fontWeight: "700",
  },
  selectWrapper: {
    width: "100%",
    borderRadius: 14,
    backgroundColor: "#f8fafc",
    borderWidth: 1,
    borderColor: "#d1d5db",
    overflow: "hidden",
  },
  select: {
    width: "100%",
    color: "#111827",
    paddingHorizontal: 12,
    minHeight: Platform.OS === "web" ? 50 : 44,
  },
  selectItem: {
    fontSize: 15,
  },
  helper: {
    marginTop: 8,
    fontSize: 12,
    color: "#6b7280",
    lineHeight: 18,
  },
  errorBorder: {
    borderColor: "#f97316",
  },
  errorText: {
    color: "#b91c1c",
  },
});

export default React.memo(SelectField);
